export const ikListKO = {
  "001": "K新宿",
  "002": "笹塚",
  "006": "桜上水",
  "008": "八幡山",
  "012": "つつじ",
  "016": "調布",
  "018": "飛田給",
  "021": "東府中",
  "022": "府中",
  "027": "高幡",
  "031": "北野",
  "032": "京八",
  "033": "N新宿",
  "036": "競馬",
  "037": "動物",
  "042": "高尾",
  "043": "高尾山",
  "048": "若葉台",
  "050": "多摩セ",
  "052": "南大沢",
  "054": "橋本",
  "107": "岩本町",
  "114": "大島",
  "118": "瑞江",
  "120": "本八幡",
  "300": "[新宿]",
  "301": "Ⓢ",
  "302": "[K新]",
  "303": "[調布]",
  "400": "[京八]",
  "401": "[高山]",
  "402": "[橋本]",
  "999": "-",
  "701": "セ　橋",
  "702": "新　セ",
  "751": "調　橋",
  "752": "新　調",
  "801": "高　八",
  "802": "新　高",
  "811": "高　山",
  "812": "新　高",
  "851": "調　八",
  "852": "新　調",
  "861": "調　山",
  "862": "新　調",
  "891": "Ｎ　本",
  "892": "本　Ｎ"
} as { [key: string]: string };

export const capitalMap = new Map<string, string>([
  ["新", "新宿"],
  ["調", "調布"],
  ["高", "高幡不動"],
  ["八", "京王八王子"],
  ["山", "高尾山口"],
  ["セ", "京王多摩センター"],
  ["橋", "橋本"],
  ["Ｎ", "新線新宿"],
  ["本", "本八幡"]
]);

export const typeList = {
  1: "特急",
  2: "急行",
  3: "快速",
  4: "準特急",
  5: "区間急行",
  6: "各駅停車",
  7: "各駅停車",
  8: "各駅停車",
  9: "京王ライナー",
  10: "臨時"
} as { [key: number]: string };

export const ikListS = {
  Shinjuku: "N新宿",
  Sasazuka: "笹塚",
  Sakurajosui: "桜上水",
  HachimanYama: "八幡山",
  Tsutsujigaoka: "つつじ",
  Wakabadai: "若葉台",
  KeioTamaCenter: "多摩セ",
  Hashimoto: "橋本",
  Takahatafudo: "高幡",
  TamaDobutsukoen: "動物",
  Takaosanguchi: "高尾山",
  KeioHachioji: "京八",
  Motoyawata: "本八幡",
  Mizue: "瑞江",
  Ojima: "大島",
  Iwamotocho: "岩本町"
} as { [key: string]: string };

export const syList = {
  Express: "#dc0000",
  Local: "#7eb500",
  1: "#cf167c",
  2: "#05B08D",
  3: "#0F4E8C",
  4: "#F79328",
  5: "#D3C427",
  6: "#808285",
  7: "#808285",
  8: "#808285",
  9: "#000000",
  10: "#57A100"
} as { [key: string]: string; [key: number]: string };
